import Vue from 'vue'
import Vuex from 'vuex'

import * as contentOverlays from './modules/content-overlays'
import * as clients from './modules/clients'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV === 'development',
  modules: {
    contentOverlays: { namespaced: true, ...contentOverlays },
    clients: { namespaced: true, ...clients },
  },
})
